import type { NodeKind } from '@/types';

/**
 * 節點連線白名單
 * -----------------------------------------------------------------------------
 * 採「可連清單」語意:沒列在這裡的組合一律不允許。
 * 新增規則時,請同步更新 `can-connect.test.ts`。
 *
 * 雙色世界觀(綠 TOOL ⇄ 藍 OUTPUT 交替生長;R137 / ADR-035 — 橘 ROOT 建卡入口下線):
 * ```
 * 綠 TOOL ──→ 藍 OUTPUT ──→ 綠 TOOL ──→ 藍 OUTPUT …
 *  (設定+素材)   (AI 產物)    (延伸)
 * ```
 *
 * - **綠 TOOL(設定 + 素材 + 需求文字)**:可互串(tool→tool 本輪 dataflow)、產出藍卡(tool→output)。
 * - **藍 OUTPUT(AI 產物)**:由 tool 產出(tool→output);可回接 tool(output→tool)延伸。
 *
 * R137:`['root','tool']` 移除(橘卡建卡入口下線,ADR-035;存量 root 卡仍唯讀渲染 =
 * 防炸,但不再能手動新拉 root→tool 邊)。禁 `output→output`(docs/76 §1.3)。
 *
 * 剛好三條:
 * @example
 *   ['tool', 'tool']     // 綠 → 綠:本輪 dataflow
 *   ['tool', 'output']   // 綠 → 藍:指令產出產物
 *   ['output', 'tool']   // 藍 → 綠:產物回接指令延伸
 */
export const ALLOWED_CONNECTIONS: ReadonlyArray<readonly [NodeKind, NodeKind]> = [
  ['tool', 'tool'],
  ['tool', 'output'],
  ['output', 'tool'],
];
